import React from 'react'
import IconsAuraExp8 from './Images/IconsAuraExp8.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard8() {
  return (

    <div className='ExpPgCard  '>
      
        <p className='ExpPgHExpName'> Dusherra festival in Kullu (Himalayan) </p>

        <p className='ExpPgHCat'> Festival </p>
        <p className='ExpPgHCode'> AURAMUSE108 </p>

        

        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp8} /> </div>
        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>




    
  )
}

export default ExpCard8